/* istanbul ignore file */
import { EntryCollection, EntrySkeletonType } from 'contentful'
import { PracticeDetailTypes, UsdaResourceConcern } from '../types/contentful'
import { getContentfulClient } from './contentful'

export class ContentfulApi {
  static async requestAll<T extends EntrySkeletonType>(type: string): Promise<any> {
    return getContentfulClient()
      .getEntries<T>({ content_type: type })
      .then((result: any) => result.items)
  }

  static async requestMarkdownByTitle<T extends EntrySkeletonType>(title: string): Promise<any> {
    return (
      getContentfulClient()
        // @ts-ignore TODO: fix 'fields.title' is not recognized by contentful types
        .getEntries<T>({ content_type: 'markdown', 'fields.title': title })
        .then((result: any) => result.items[0])
    )
  }
  static async requestTerms<T extends EntrySkeletonType>(): Promise<any> {
    return getContentfulClient()
      .getEntries<T>({ content_type: 'termsPolicyDataUse' })
      .then((result: any) => result.items)
  }

  static async requestTermsByName<T extends EntrySkeletonType>(name: string): Promise<any> {
    return getContentfulClient()
      .getEntries<T>({
        content_type: 'termsPolicyDataUse',
        // @ts-ignore TODO: fix 'fields.title' is not recognized by contentful types
        'fields.name': name,
      })
      .then((result: any) => result.items[0])
  }

  static async getAsset<T extends string>(id: string): Promise<any> {
    return getContentfulClient().getAsset<T>(id)
  }

  static async find<T extends EntrySkeletonType>(query: any): Promise<any> {
    return getContentfulClient()
      .getEntries<T>(query)
      .then((result: any) => result.items)
  }

  static async getEntry<T extends EntrySkeletonType>(id: string): Promise<any> {
    return getContentfulClient().getEntry<T>(id)
  }

  static async findEntries<T extends EntrySkeletonType>(query: any): Promise<EntryCollection<T>> {
    return getContentfulClient().getEntries<T>(query)
  }

  static async requestPracticesInfo(locale: string): Promise<EntryCollection<PracticeDetailTypes>> {
    return getContentfulClient().getEntries<PracticeDetailTypes>({
      content_type: 'practiceRecommendation',
      locale,
    })
  }

  static async requestResourceConcernsDefinition(
    locale: string
  ): Promise<EntryCollection<UsdaResourceConcern>> {
    return getContentfulClient().getEntries<UsdaResourceConcern>({
      content_type: 'usdaResourceConcern',
      locale,
    })
  }
}
